import { Stack, Box, Link, Text } from '@chakra-ui/react';
import { PlanProps } from '@/components/PricingPlan/types';
import React from 'react';

const DeveloperPlanCover: React.FC<PlanProps> = ({ t, language, currency, price }) => {
  return (
    <Stack align="center" h="100px" justify="center">
      <Text color="blue.500" fontSize="4xl" fontWeight="bold">
        {`${currency}${price}`}
        <Text display="inline" fontSize="xs">
          /{t('monthly')}
        </Text>
      </Text>
      <Box w="full">
        <Text color="blue.500" fontSize="xs" fontWeight="bold" textAlign="right">
          {language === 'en' ? '10% discount with annual subscription' : '年間契約で10%オフ'}
          <br />
          {language === 'en' ? 'Contact us ' : 'お問い合わせは'}
          <Link href="https://corporate.pretiaar.com/inquiry/" textDecoration="underline">
            {language === 'en' ? 'here' : 'こちら'}
          </Link>
          {language === 'en' ? ' if you have any question' : ''}
        </Text>
      </Box>
    </Stack>
  );
};

export default DeveloperPlanCover;
